import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import ParticipantStore from '../../../../../../ParticipantStore';
import WithField from '../../../../../../Resource/FormTemplates/Inputs/WithField';
import { T } from '../../../../../../Translations';
import FlashError from '../../../../../FlashMessage/FlashError';
import LicenseAllocationsStore from '.././Store';
import { Ready } from '.././Types';
import Form from './Form';

interface Props {
  state: Ready;
  licenseAllocationsStore: LicenseAllocationsStore;
  participantStore: ParticipantStore;
}

function ReadyView({ state, licenseAllocationsStore }: Props) {
  return (
    <WithField kind="multiple-selection" name="license_ids" fields={state.template.fields}>
      {(field) =>
        fromArrayMaybe(state.resource.payload.allocatableLicenses)
          .map(() => <Form field={field} licenseAllocationsStore={licenseAllocationsStore} />)
          .getOrElse(() => (
            <FlashError>
              <T kind="No licenses are available for allocation to this..." />
            </FlashError>
          ))
      }
    </WithField>
  );
}

export default observer(ReadyView);
